var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterYourself(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.867,77.531H69.52a2.174,2.174,0,0,0-2.19,2.189,2.231,2.231,0,0,0,2.19,2.19H86.867a2.19,2.19,0,0,0,0-4.379",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.867,88.562H69.52a2.174,2.174,0,0,0-2.19,2.189,2.23,2.23,0,0,0,2.19,2.19H86.867a2.19,2.19,0,0,0,0-4.379",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.867,99.594H69.52a2.174,2.174,0,0,0-2.19,2.189,2.23,2.23,0,0,0,2.19,2.19H86.867a2.189,2.189,0,0,0,0-4.379",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.688,77.531H59.667a2.174,2.174,0,0,0-2.19,2.189,2.231,2.231,0,0,0,2.19,2.19h2.021a2.19,2.19,0,0,0,0-4.379",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.688,88.562H59.667a2.174,2.174,0,0,0-2.19,2.189,2.23,2.23,0,0,0,2.19,2.19h2.021a2.19,2.19,0,0,0,0-4.379",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.688,99.594H59.667a2.174,2.174,0,0,0-2.19,2.189,2.23,2.23,0,0,0,2.19,2.19h2.021a2.189,2.189,0,0,0,0-4.379",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,65.32,83.915,50.25a2.309,2.309,0,0,0-1.6-.68H72.135a18.437,18.437,0,1,0-25.27,20.8v42.44a2.17,2.17,0,0,0,2.19,2.19h48.25a2.17,2.17,0,0,0,2.19-2.19V66.92a1.641,1.641,0,0,0-.5-1.6M82.745,55.3l11.2,11.2h-11.2Zm-42.61-1.85A13.975,13.975,0,1,1,54.1,67.43a13.941,13.941,0,0,1-13.97-13.98m55.15,57.18H51.415V71.64a15.621,15.621,0,0,0,2.78.25,18.4,18.4,0,0,0,18.36-17.77h5.81V68.86a2.176,2.176,0,0,0,2.19,2.19h14.73Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.945,66.5h-11.2V55.3Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1,39.47a13.98,13.98,0,1,0,13.98,13.98A13.941,13.941,0,0,0,54.1,39.47m7.84,11.37-8.09,8.08a2.245,2.245,0,0,1-3.2,0l-4.21-4.21a2.206,2.206,0,1,1,3.12-3.12l2.69,2.7,6.49-6.49a2.208,2.208,0,0,1,3.2,3.04",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.945,50.84l-8.09,8.08a2.245,2.245,0,0,1-3.2,0l-4.21-4.21a2.206,2.206,0,1,1,3.12-3.12l2.69,2.7,6.49-6.49a2.208,2.208,0,0,1,3.2,3.04",
    fill: "#2b528e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterYourself);
export default __webpack_public_path__ + "static/media/register_yourself.911b2ab95c303931187388d2ecebe6da.svg";
export { ForwardRef as ReactComponent };